
import { supabase } from '@/integrations/supabase/client';
import { ScheduleAlert } from '../types';
import { format } from 'date-fns';

export const fetchScheduleAlerts = async (
  startDate: Date, 
  endDate: Date, 
  teamId: string | null = null
): Promise<ScheduleAlert[]> => {
  try {
    // Format the dates to match the format stored in the database (YYYY-MM-DD)
    const formattedStartDate = format(startDate, 'yyyy-MM-dd');
    const formattedEndDate = format(endDate, 'yyyy-MM-dd');
    
    console.log(`Fetching alerts from ${formattedStartDate} to ${formattedEndDate}`);
    
    let query = supabase
      .from('schedule_alerts')
      .select('*')
      .gte('week_start_date', formattedStartDate)
      .lte('week_start_date', formattedEndDate)
      .order('created_at', { ascending: false });
    
    // Add team filter if a team is selected
    if (teamId) {
      query = query.eq('team_id', teamId);
    }
    
    const { data, error } = await query;
    
    if (error) {
      console.error('Error fetching schedule alerts:', error);
      throw error;
    }
    
    return data as ScheduleAlert[];
  } catch (error) {
    console.error('Error in fetchScheduleAlerts:', error);
    return [];
  }
};
